import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div className="cookie-bar">
      <p>
        Questo sito utilizza i cookie per migliorare l'esperienza dell'utente.{" "}
        {/*<Link to="#">Leggi di più</Link>*/}
      </p>
      <button onClick={handleAccept}>Accetta</button>
      {/*<button onClick={handleDecline}>Rifiuta</button>*/}
    </div>
  );
};

export default CookieBar;
